<template lang="pug">
.row

  .col-sm-6
    .form-group(:class="{'has-error': errors.has('title') || existing_title}")
      input.form-control(name="title",
                         type="text",
                         v-model="title",
                         v-validate="'required'",
                         placeholder="Digite o nome da reunião")
      transition-group(name='fade')
        .help-block(v-show="errors.has('title')", key="title") Favor preencher o campo acima
        .help-block(v-show="existing_title", key="existing_title") O tipo de reunião já existe

  .col-sm-5
    button.btn.btn-primary(@click="submit")
      span.icon-more +
      | Adicionar tipo de reunião

  .clear
  br
</template>

<script>
const helpers = require("../../helpers.coffee");

const view_model = {
  data() {
    return {
      title: "",
      existing_title: false
    };
  },

  methods: {
    submit() {
      this.$validator.validateAll({ title: this.title }).then(success => {
        if (success) {
          if (this.search(this.title, this.$store.getters.meetingTypesList)) {
            this.existing_title = true;
          } else {
            this.createMeetingType();
          }
        }
      });
    },

    search(titleKey, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].title === titleKey) {
          return true;
        }
      }
    },

    createMeetingType() {
      this.$store.dispatch("createMeetingType", { title: this.title });
      this.title = ""
    }
  },
  watch: {
    title: function(newTitle, oldTitle) {
      if (newTitle === "") {
        this.existing_title = false;
      }
    }
  }
};

exports.default = helpers.vue_include(view_model, helpers.form);
</script>

<style lang="sass" scoped>

  @import "../../assets/stylesheets/_variables.sass"

  input.form-control
    height: 38px

  .table-col
    padding-left: 20px
    padding-right: 20px


</style>



// WEBPACK FOOTER //
// new.vue?3f100119